import rezone from '../helpers/rezone.fn.js';

document.addEventListener('update_competition', (e) => {

	let existing = e.detail.initiator.closest('.competition');
	existing.insertAdjacentHTML('afterend', e.detail.payload.markup);
	
	[... existing.nextElementSibling.querySelectorAll('[data-date]')].map((el) => rezone(el));

	existing.remove();


});


